import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="bg-[#06080C] text-white min-h-[70vh] flex flex-col items-center justify-center text-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 warning-stripes opacity-15" />
      <div className="relative">
        <div className="font-mono text-xs uppercase tracking-[0.35em] text-[#C54A4A]">
          Error 404 // Sector Not Found
        </div>
        <h1 className="mt-4 font-display text-5xl sm:text-7xl uppercase tracking-[0.1em] etched leading-none">
          Off the Map
        </h1>
        <p className="mt-4 text-[#A0A6B5] max-w-md mx-auto">
          This page doesn't exist. Head back to the main menu and pick a mode.
        </p>
        <Link
          to="/home"
          className="mt-8 inline-flex items-center gap-2 border border-[#D4AF37] hover:bg-[#D4AF37] hover:text-black text-[#D4AF37] px-6 py-3 font-mono uppercase tracking-[0.3em] text-[11px] transition-colors"
        >
          Return to Main Menu
        </Link>
      </div>
    </div>
  );
}
